module.exports = __webpack_public_path__ + "media/images/bg_mv_selling_property_sp-54b0aa5ec0c35e4514aaad78d77bbe37.jpg";